module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "container"
    }
  }, [(_vm.loading) ? _c('p', {
    staticClass: "u-loading"
  }, [_vm._v("正在加载，请稍候......")]) : _vm._e(), _vm._v(" "), (_vm.loaded) ? _c('div', {
    staticClass: "m-result"
  }, [_c('searchBar', {
    attrs: {
      "keyword": _vm.search.keyword,
      "flag": 0
    },
    on: {
      "getSearch": _vm.searchList,
      "getshowModel": _vm.openCase
    }
  }), _vm._v(" "), _c('mu-table', {
    attrs: {
      "fixedFooter": true,
      "height": _vm.tableH,
      "selectable": false,
      "showCheckbox": false
    }
  }, [_c('mu-thead', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('mu-tr', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('mu-th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("患者信息")]), _vm._v(" "), _c('mu-th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("订单号")]), _vm._v(" "), _c('mu-th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("开单信息")]), _vm._v(" "), _c('mu-th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("订单信息")]), _vm._v(" "), _c('mu-th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("操作")])], 1)], 1), _vm._v(" "), (_vm.orderLists.length > 0) ? _c('mu-tbody', _vm._l((_vm.orderLists), function(order, index) {
    return _c('mu-tr', {
      staticStyle: {
        "height": "90px"
      }
    }, [_c('mu-td', {
      attrs: {
        "width": "20%"
      },
      on: {
        "click": function($event) {
          _vm.toCaseInfo(order.id, order)
        }
      }
    }, [_c('personal', {
      attrs: {
        "info": order,
        "keys": index,
        "flag": 1
      }
    })], 1), _vm._v(" "), _c('mu-td', {
      attrs: {
        "width": "20%"
      }
    }, [_c('span', [_c('a', [_vm._v(_vm._s(order.id))])])]), _vm._v(" "), _c('mu-td', {
      attrs: {
        "width": "20%"
      }
    }, [_c('span', [_c('a', [_vm._v(_vm._s(order.doc_name) + "，" + _vm._s(_vm._f("date")(order.add_time)))])])]), _vm._v(" "), _c('mu-td', {
      attrs: {
        "width": "30%"
      }
    }, [_c('span', [_c('a', [_vm._v("￥" + _vm._s(order.order_total_fee) + "，" + _vm._s(_vm._f("date")(order.order_use_start_time)) + "，\n              " + _vm._s(order.order_days) + "天，" + _vm._s(_vm._f("payed")(order.order_status)))])])]), _vm._v(" "), _c('mu-td', {
      attrs: {
        "width": "10%"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'orderInfo',
          params: {
            id: order.id
          },
          query: {
            order: order
          }
        }
      }
    }, [_vm._v("查看详情")])], 1)], 1)
  })) : _c('mu-tbody', [_c('mu-tr', [_c('mu-td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("---暂无订单信息---")])], 1)], 1), _vm._v(" "), (_vm.orderLists.length > 0) ? _c('mu-tfoot', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('mu-tr', [_c('mu-pagination', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "total": _vm.totalNum,
      "current": _vm.curPage
    },
    on: {
      "pageChange": _vm.handleClick
    }
  }), _vm._v(" "), _c('mu-td', {
    staticStyle: {
      "padding-top": "20px",
      "text-align": "right"
    }
  }, [_vm._v("共 " + _vm._s(_vm.totalNum) + " 条记录")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showModal) ? _c('orderModal', {
    attrs: {
      "orgId": _vm.orgId
    },
    on: {
      "close": _vm.closeCase
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-430749a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/order/orderList.vue
// module id = 981
// module chunks = 2